module.exports = __webpack_public_path__ + "resources/icon_94_gonggaono.de8bff4b9ddef0b8.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-manage/manage-dialog/img/icon_94_gonggaono.png
// module id = 621
// module chunks = 0 1 2 3